import { Component, Input, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-stepper-container',
  templateUrl: './stepper-container.component.html',
  styleUrls: ['./stepper-container.component.scss'],
  standalone: false
})
export class StepperContainerComponent implements OnInit {
  @Input() hideLeftOnMobile = false;
  @Input() hideRightOnMobile = false;
  @Input() hideLeftOnTablet = false;
  @Input() hideRightOnTablet = false;
  @Input() isAgendaCompleted = false;

  isMobile = false;
  isTablet = false;

  @HostListener('window:resize', ['$event'])
  onResize(event:Event) {
    this.checkScreenSize();
  }

  ngOnInit() {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    const width = window.innerWidth;
    this.isMobile = width <= 768;
    this.isTablet = width > 768 && width <= 1024;
  }
}
